export const moveSigner = <T,>(items: readonly T[], index: number, direction: -1 | 1): T[] => {
  const nextIndex = index + direction;
  const next = [...items];
  if (index < 0 || nextIndex < 0 || nextIndex >= next.length) return next;
  [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
  return next;
};
